import { produce } from 'immer';
import _ from 'lodash';

import { LoanChangesHistoryState } from 'constants/loanApplication';
import { resolvePendingChangePropertyKey } from 'utils/pendingChanges';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_CHANGES_HISTORY_ACTION_TYPE } from '../actions';

const initialState = {
  changes: {},
  protectedChanges: {},
};

const getUpdatedLoanChanges = (newChanges, initialChanges) => {
  const result = _.cloneDeep(initialChanges);

  newChanges?.forEach(item => {
    if (!result[item.entityPrimaryKey]) {
      result[item.entityPrimaryKey] = [];
    }

    if (item.historyState === LoanChangesHistoryState.CANCELLED) {
      result[item.entityPrimaryKey] = result[item.entityPrimaryKey].filter(
        draftItem =>
          resolvePendingChangePropertyKey(draftItem) !== resolvePendingChangePropertyKey(item),
      );

      return;
    }

    result[item.entityPrimaryKey].push(item);
  });

  return result;
};

const loanChangesHistoryReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_CHANGES_HISTORY_ACTION_TYPE.GET_CHANGES_HISTORY:
        draft.changes = payload || initialState.changes;
        draft.protectedChanges = {};
        break;

      case LOAN_CHANGES_HISTORY_ACTION_TYPE.UPDATE_ENTITIES_CHANGES_HISTORY:
        {
          const { changes, isProtected } = payload;

          draft.changes = getUpdatedLoanChanges(changes, draft.changes);

          if (isProtected) {
            draft.protectedChanges = getUpdatedLoanChanges(changes, draft.protectedChanges);
          }
        }

        break;

      case LOAN_CHANGES_HISTORY_ACTION_TYPE.CLEAN_PROTECTED_ENTITIES_CHANGES_HISTORY:
        draft.protectedChanges = {};
        break;

      case LOAN_CHANGES_HISTORY_ACTION_TYPE.DELETE_CHANGES_HISTORY:
        draft.changes = draft.protectedChanges;
        draft.protectedChanges = {};
        break;

      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default loanChangesHistoryReducer;
